var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mx-page',{staticClass:"p10",attrs:{"type":"Home","theme":"Panel","title":"已邀学员","name":"已邀学员","config":_vm.config,"parent":_vm.value,"parent-type":_vm.config.Type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }